import React, { createContext, useContext, useState } from "react";

const BrandingContext = createContext();

//  Get initial branding instantly
const getInitialBranding = () => {
  try {
    const cached = localStorage.getItem("branding");

    if (cached) {
      return JSON.parse(cached);
    }
  } catch (error) {
    console.log(error);
  }

  return {
    title: "Secure Pay",
    favicon: "/favicon.png",
  };
};

export const BrandingProvider = ({ children }) => {
  //  Load localStorage before render
  const [branding, setBranding] = useState(getInitialBranding);

  return (
    <BrandingContext.Provider
      value={{
        branding,
        setBranding,
      }}
    >
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
